import React from "react";
import classNames from "classnames";
import Icon from "components/Icon";

const ButtonIconOnly = React.forwardRef(({
  id,
  dataCy,
  icon, // Icon name from the iconMap
  iconFill = "none", // Icon fill color
  type = "default", // "default", "alt", "uncontained"
  disabled = false, // Button state
  size = 24, // Icon size: 24px or 20px
  onClick,
  buttonType = "button",
  onMouseEnter,
  onMouseLeave
}, ref) => {
  if (!icon) return null; // Ensure an icon is always provided

  // Mapping button sizes based on the icon size
  const buttonSize = size === 24 ? "w-12 h-12" : "w-9 h-9";
  const iconSize = size === 24 ? "w-6 h-6" : "w-5 h-5";

  // Base styles
  const baseStyles =
    "flex items-center justify-center transition-all duration-200 rounded-full outline outline-transparent";

  // Define styles for each icon-only type
  const typeStyles = {
    default: `bg-[var(--color-white)] border border-[var(--color-gray-100)] ${!disabled ? "hover-border-thicker-icon" : ""}`,
    alt: `bg-[var(--color-gray-50)]`,
    uncontained: `hover:bg-[var(--color-gray-100)]`,
  };

  // Disabled styles
  const disabledStyles = disabled
    ? "opacity-50 cursor-not-allowed border-[var(--color-gray-100)] bg-inherit hover:bg-inherit"
    : "";

  // Icon color logic
  const iconColor = disabled
    ? "text-[var(--color-gray-300)]"
    : "text-[var(--color-gray-800)]";

  return (
    <button
      ref={ref}
      id={id}
      data-cy={dataCy}
      className={classNames(baseStyles, buttonSize, typeStyles[type], disabledStyles)}
      onClick={onClick}
      disabled={disabled}
      type={buttonType}
      onMouseEnter={onMouseEnter}
      onMouseLeave={onMouseLeave}
    >
      <Icon
        name={icon}
        size={size}
        fillColor={iconFill}
        className={classNames(iconSize, iconColor)}
      />
    </button>
  );
});

export default ButtonIconOnly;
